import React from 'react';
import { useNavigate } from 'react-router-dom';
import { message } from 'antd';
import ImportForm from './components/importForm';
import useProductState from './hooks/useProductState';


const ProductImportPage = () => {
  const navigate = useNavigate(); 
  const { importProducts } = useProductState();
  
  const handleImport = async (products) => {
    const response = await importProducts(products);
    if(response.success) {
      message.success('Products imported successfully!');
      navigate('/products');
    } else {
      message.error('Failed to import products.');
    }
  };

  return (
    <div className="import-page">
      <h3>Import Products</h3>
      <ImportForm
        onSubmit={handleImport}
        expectedFields={['Product', 'Name', 'Description', 'Sale Price', 'License Type',
          'Bundle', 'Bundled Products', 'Version']} // Define required Excel headers
      />
    </div>
  );
};

export default ProductImportPage;
